module.exports = __webpack_public_path__ + "img/TIF_Group_Logo_Portrait.a57ec72b.png";